import { render, staticRenderFns } from "./Back.vue?vue&type=template&id=69c64caf"
import script from "./Back.vue?vue&type=script&lang=js"
export * from "./Back.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports